export const PB_HOST_URL = process.env.REACT_APP_PB_HOST;
export const API_URL = `${PB_HOST_URL}/api`;